import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=0c3b40c1&scoped=true&"
import script from "./Voice.vue?vue&type=script&lang=js&"
export * from "./Voice.vue?vue&type=script&lang=js&"
import style0 from "./Voice.vue?vue&type=style&index=0&id=0c3b40c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b40c1",
  null
  
)

export default component.exports